<template>
  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
    <template v-slot:activator="{on}">
      <v-text-field v-model="formattedDate" prepend-icon="event" readonly v-on="on" :label="label"></v-text-field>
    </template>
    <v-date-picker v-model="date" @input="setDate()" :first-day-of-week="0" locale="jp-ja" :day-format="date => new Date(date).getDate()" :title-date-format="(date) => {return date.replace('-','/').replace('-', '/') }">
    </v-date-picker>
  </v-menu>
</template>
<script>
import { moment, unixtimeToFormattedDate, FormattedDateTounixtime, unixtimeToFormattedDatetime, unixtimeToDate } from "@/utils/datetime.js"


export default {
  data: () => ({
    menu: false,
    date: ""
  }),
  props: {
    value: {
      default: 0,
      type: Number,
    },
    label: {
      default: "",
      type: String
    }

  },
  mounted() {
  },
  watch: {
    value() {
      this.date = Number.isInteger(this.value) ? unixtimeToFormattedDate(this.value) : unixtimeToFormattedDate(0)
    },
    menu(val) {
      // val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  computed: {

    hour: {
      get() {
        return moment.unix(this.value).hour()
      },
      set(hour) {
        const m = moment.unix(this.value)
        m.hour(hour)
        this.$emit('input', m.unix())
      }
    },
    min: {
      get() {
        return moment.unix(this.value).minute()
      },
      set(min) {
        const m = moment.unix(this.value)
        m.minute(min)
        this.$emit('input', m.unix())
      }
    },
    formattedDate: {
      get() {
        return unixtimeToFormattedDate(this.value)
      },
      set(formattedDate) {
        const m = moment(formattedDate).hour(0).minute(0)
        this.$emit('input', m.unix())
      }
    },
  },
  methods: {
    setDate() {
      this.formattedDate = this.date
      this.menu = false
    }
  }
}
</script>

